import React, { useContext } from "react";
import Flow from "student-front-commons/src/components/Flow";
import { LOGOUT_FLOW } from "consts";
import MenuItem from "core/MenuItem";
import WhitelabelContext from "student-front-commons/src/components/WhitelabelContext";

function LogoutMenuItemContainer() {
  const whitelabelContext = useContext(WhitelabelContext);

  return (
    <Flow
      id={LOGOUT_FLOW}
      params={{
        isSsoOnly: whitelabelContext.isSsoOnly("KIDS"),
        redirectUrl: whitelabelContext.getSsoRedirectUrl("KIDS"),
      }}
    >
      {({ handleStart }) => <MenuItem label="menu.logout" onClick={handleStart} />}
    </Flow>
  );
}

export default LogoutMenuItemContainer;
